import styled from 'styled-components';


const MainLayout = styled.div`
  background-color: ${props => props.color};
  ${props => props.center && 'align-items: center;'}
  ${props => props.positionC && 'justify-content: center;'}
  padding: ${props => `${props.padding}px`};
  width: ${props => props.width ? `${props.width}px` : 'width: 100%;'};
  height: ${props => props.height ? `${props.height}px` : 'width: 100%;'};
  border-radius: ${props => `${props.radius}px`};
  display: flex;
  flex-direction: column;
`;

const Layout = styled.div`
  background-color: ${props => props.color};
  ${props => props.row ? 'flex-direction: row;' : 'flex-direction: column;'}
  ${props => props.space && 'justify-content: space-between;'}
  ${props => props.positionR && 'justify-content: flex-end;'}
  ${props => props.positionL && 'justify-content: flex-start;'}
  ${props => props.positionC && 'justify-content: center;'}
  ${props => props.center && 'align-items: center;'}
  display: flex;
  width: 100%;
  height: auto
`;

const LayoutChild = styled.div`
  background-color: ${props => props.color};
  width: ${props => `${props.width}px`};
  width: ${props => `${props.percent}%`};
  margin: ${props => props.margin};
  padding: ${props => `${props.padding}px`};
  border-radius: ${props => `${props.radius}px`};
  border:  ${props => `${props.border}`};;
  ${props => props.row ? 'flex-direction: row;' : 'flex-direction: column;'}
  ${props => props.space && 'justify-content: space-between;'}
  ${props => props.positionR && 'justify-content: flex-end;'}
  ${props => props.positionC && 'justify-content: center;'}
  ${props => props.left && `margin-left: ${props.left}px;`}
  ${props => props.top && `margin-top: ${props.top}px;`}
  ${props => props.center && 'align-items: center;'}
  display: flex;
  height: auto
`


const Columns = styled.div`
  background-color: ${props => props.color};
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  height: auto;
  grid-gap: 20px;
`;


const AdjustableColumns = styled.div`
  background-color: ${props => props.color};
  display: grid;
  grid-template-columns: ${props => props.listWith}px repeat(auto-fit, minmax(320px, 1fr));
  height: auto;
  grid-gap: 20px;
  padding: 10px;
`;


const FormContainer = styled.div`
  padding: 10px;
  margin-top: 20px;
`;


export {Columns, MainLayout, Layout, LayoutChild, FormContainer, AdjustableColumns};
